import React, { FunctionComponent } from "react"
import Grid from "../../components/Grid/Grid"
import LinkItem from "../../components/Grid/LinkItem"
import Loader from "../../components/Loader/Loader"
import Pagination from "../../components/Pagination/Pagination"
import Seo from "../../components/Seo/Seo"
import { iRoles, iRolesQuery } from "../../definitions/Roles"
import { useData } from "../../hooks/useData"
import Item from "./Item"

const Roles: FunctionComponent = () => {
  const { data, total, setQuery, loading } = useData<iRolesQuery, iRoles>({
    link: "/v1/roles",
    defaultQuery: {},
    shouldPingForData: true,
    shouldPushQuery: true,
  })

  return (
    <>
      <Seo title={"Roles"} />
      <div className="content">
        <div className="content-header">
          <h1>Roles ({total})</h1>
        </div>
        <div className="grid-wrap">
          {loading ? (
            <Loader />
          ) : data.length ? (
            <Grid>
              {data.map((role) => (
                <LinkItem key={role._id} url={"/roles/" + role._id}>
                  <Item {...role} />
                </LinkItem>
              ))}
            </Grid>
          ) : (
            <div className="no-data">No matching results.</div>
          )}
        </div>
        <Pagination total={total} limit={50} setQuery={setQuery} />
      </div>
    </>
  )
}

export default Roles
